import React from "react";
import bar from "../../assets/barraDivisora.png";
import brands from "../../assets/logosEmpresas.png";

export const EffectiveSolutionsSection: React.FC = () => {
  return (
    <section className="relative h-screen w-full bg-black flex items-start justify-center lg:pt-[20%] pt-[50%]">
      <div className="w-full max-w-6xl">
        <h2 className="text-white text-center uppercase font-bold leading-[1.46] text-lg lg:text-3xl">
          <span className="text-white">creadores</span> de soluciones efectivas
          y de
          <br /> alto impacto, con <span className="text-white">
            talento
          </span>{" "}
          comprometido
          <br /> en la generación de valor para <br /> nuestros clientes.
        </h2>

        {/* Bottom brand bar */}
        <div className="absolute bottom-0 left-0 right-0 flex flex-col items-end justify-center">
          <img
            draggable={false}
            src={bar}
            alt="barra divisora"
            className="w-full"
          />
          <img
            draggable={false}
            src={brands}
            alt="marcas"
            className="w-full px-12"
          />
        </div>
      </div>
    </section>
  );
};
